import { useCallback } from 'react';
import doneSound from '../assets/audio/done.mp3';
import deleteSound from '../assets/audio/delete.mp3';
export function useSounds() {
  const playDoneSound = useCallback(() => {
    const audio = new Audio(doneSound);
    audio.play().catch(e => console.error('Audio play failed', e));
  }, []);
  const playDeleteSound = useCallback(() => {
    const audio = new Audio(deleteSound);
    audio.play().catch(e => console.error('Audio play failed', e));
  }, []);
  return {
    playDoneSound,
    playDeleteSound
  };
}
